import {useEffect, useState} from 'react';
import {WdiFormCardTitle, WdiTextArea} from '@/components/WdiControls';
import {Col, Form, Row} from 'antd';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import {WdiPanel, WdiPanelProps} from '@/components/WdiControls/WdiPanel';
import {FormApi} from '@/services/sales';
import {FormSs} from '@/services/sales/ss';
import {Enum} from '@/enums/system';

export type DetailForApplyProps = {
  formRef: any;
  formSsId?: number;
} & WdiPanelProps;

const FormSsInfosApp: React.FC<DetailForApplyProps> = (props) => {
  const [ssForm, setSSForm] = useState<API.Form>();
  useEffect(() => {
    if (props.formSsId && props.formRef) {
      FormSs.get(props.formSsId).then(formSSResponse => {
        const formSs = formSSResponse?.data;
        props.formRef.current?.setFieldsValue({
          SSRemark: formSs.remark,
          differenceDesc: formSs.differenceDesc,
          SSAttachment: FileUploadUtility.parse(formSs.fileName, formSs.filePath),
        })
      })
      FormApi.get(props.formSsId).then(saFormResponse => {
        setSSForm(saFormResponse?.data);
      })
    }
  }, [props.formSsId]);
  return (
    <>
      <WdiPanel collapsed={true} {...props}
                title={<WdiFormCardTitle iconType={Enum.IconType.FORM_SS} title='活动结案单信息' form={ssForm}
                                         isJump={true}/>}>
        <Row gutter={[16, 24]}>
          <Col className="gutter-row" span={8}>
            <Form.Item name="SSRemark" label="活动效果说明">
              <WdiTextArea rows={4} readOnly/>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item name="differenceDesc" label="整体差异说明">
              <WdiTextArea rows={4} readOnly/>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              name="SSAttachment"
              label="附件"
              valuePropName='fileList'
              getValueFromEvent={(e: any) => {
                return e.fileList || [];
              }}
            >
              <WdiFileList/>
            </Form.Item>
          </Col>
        </Row>
      </WdiPanel>
    </>
  );
}
export default FormSsInfosApp;

